import { render, staticRenderFns } from "./TOGmanagement.vue?vue&type=template&id=a57187c0&scoped=true"
import script from "./TOGmanagement.vue?vue&type=script&lang=js"
export * from "./TOGmanagement.vue?vue&type=script&lang=js"
import style0 from "./TOGmanagement.vue?vue&type=style&index=0&id=a57187c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57187c0",
  null
  
)

export default component.exports